import { NavigationSectionType } from './SecondaryNavBars/common/DynamicNavigation'
import {
  ChartLineUp,
  Package,
  SealPercent,
  Gift,
  Lightning,
  Megaphone,
  Scroll,
  HandWaving,
  Compass,
  UsersThree,
  Storefront,
  Question,
  Gear,
  MoneyWavy,
  Flag,
  House
} from '@phosphor-icons/react'
import { NavigationItem } from './PrimaryNavBarComponents/PrimaryTabs'
import { shouldShowNavNewBadgeById } from './nav-new-badges'

export const cartSections: NavigationSectionType[] = [
  {
    title: 'Customise',
    items: [
      {
        id: 'cart-core-setup',
        title: 'Core Setup',
        path: '/cart/ui',
        rbacPermission: 'CORE_SETUP_CART'
      },
      {
        id: 'cart-coupon-setup',
        title: 'Coupons Page',
        path: '/cart/coupons',
        rbacPermission: 'COUPONS_PAGE_CHECKOUT'
      }
    ]
  },
  {
    title: 'Manage',
    items: [
      {
        id: 'cart-widget',
        title: 'Widget',
        path: '/cart/widget',
        rbacPermission: 'CART_WIDGET'
      },
      {
        id: 'cart-analytics',
        title: 'Analytics',
        path: '/cart/cart-analytics',
        rbacPermission: 'CART_ANALYTICS'
      }
    ]
  }
]

export const pdpSections: NavigationSectionType[] = [
  {
    title: 'Customise',
    items: [
      {
        id: 'pdp-core-setup',
        title: 'Core Setup',
        path: '/pdp/core-setup',
        rbacPermission: 'CORE_SETUP_PDP_EDIT'
      }
    ]
  },
  {
    title: 'Widgets',
    items: [
      {
        id: 'pdp-widget-delivery',
        title: 'Delivery',
        path: '/pdp/widgets/delivery',
        rbacPermission: 'CORE_SETUP_PDP_EDIT'
      }
    ]
  },
  {
    title: 'Manage',
    items: [
      {
        id: 'pdp-analytics',
        title: 'Analytics',
        path: '/pdp/pdp-analytics',
        rbacPermission: 'PDP_ANALYTICS'
      }
    ]
  }
]

export const checkoutSections: NavigationSectionType[] = [
  {
    title: 'Customise',
    items: [
      {
        id: 'checkout-core-setup',
        title: 'Core Setup',
        path: '/style/elements',
        rbacPermission: 'CORE_SETUP_CHECKOUT'
      },
      {
        id: 'checkout-brand',
        title: 'Brand',
        path: '/style/brand',
        rbacPermission: 'BRAND_DETAILS_CHECKOUT'
      },
      {
        id: 'checkout-login-page',
        title: 'Login Page',
        path: '/style/login',
        rbacPermission: 'LOGIN_PAGE_CHECKOUT'
      },
      {
        id: 'checkout-coupons',
        title: 'Coupons',
        path: '/style/coupons',
        rbacPermission: 'COUPONS_PAGE_CHECKOUT'
      },
      {
        id: 'checkout-address-page',
        title: 'Address Page',
        path: '/style/address',
        rbacPermission: 'ADDRESS_PAGE'
      },
      {
        id: 'checkout-payment-page',
        title: 'Payment Page',
        path: '/style/payment',
        rbacPermission: 'PAYMENTS_PAGE'
      },
      {
        id: 'checkout-order-confirmation',
        title: 'Order Confirmation',
        path: '/style/order-confirmation',
        rbacPermission: 'TAB_THANK_YOU_PAGE'
      }
    ]
  },
  {
    title: 'Manage',
    items: [
      {
        id: 'checkout-shipping-zone',
        title: 'Shipping Zone',
        path: '/shipping-delivery',
        rbacPermission: 'TAB_SHIPPING_DELIVERY_V2'
      },
      {
        id: 'checkout-rto',
        title: 'RTO',
        path: '/rto-suite',
        rbacPermission: 'TAB_RTO_SUITE'
      },
      {
        id: 'checkout-upsell',
        title: 'Upsell',
        path: '/upsell',
        rbacPermission: ['TAB_UPSELL_LITE', 'TAB_UPSELL']
      },
      {
        id: 'checkout-experiments',
        title: 'A/B Experiments',
        path: '/experiments',
        rbacPermission: 'TAB_EXPERIMENTS'
      },
      {
        id: 'checkout-category-insights',
        title: 'Category Insights',
        path: '/insights',
        rbacPermission: 'TAB_CATEGORIES_INSIGHTS'
      },
      {
        id: 'checkout-quick-add-on',
        title: 'Quick Add-Ons',
        path: '/quick-add-on',
        rbacPermission: 'TAB_ONE_CLICK_ADDON'
      },
      {
        id: 'checkout-subscriptions',
        title: 'Subscriptions',
        path: '/subscriptions',
        rbacPermission: 'TAB_SUBSCRIPTIONS',
        showNewBadge: shouldShowNavNewBadgeById('checkout-subscriptions')
      },
      {
        id: 'checkout-shopify-bundles',
        title: 'Product Bundles',
        path: '/product-bundles',
        rbacPermission: 'TAB_SHOPIFY_BUNDLES'
      },
      {
        id: 'checkout-gift-cards',
        title: 'Gift Cards',
        path: '/gift-cards',
        rbacPermission: ''
      }
    ]
  }
]

export const shopPassSections: NavigationSectionType[] = [
  {
    title: 'Manage',
    items: [
      {
        id: 'shoppass-analytics',
        title: 'Analytics',
        path: '/sso/analytics',
        rbacPermission: 'VIEW_SSO_ANALYTICS'
      },
      {
        id: 'shoppass-identified-contacts',
        title: 'Identified Contacts',
        path: '/sso/identified-contacts',
        rbacPermission: 'SHOPPASS_REPORT_TAB'
      }
    ]
  },
  {
    title: 'Customise',
    items: [
      {
        id: 'shoppass-core-setup',
        title: 'Core Setup',
        path: '/sso/setup',
        rbacPermission: 'VIEW_SSO_SETUP'
      },
      {
        id: 'shoppass-accounts-page',
        title: 'Accounts Page',
        path: '/sso/accounts-page',
        rbacPermission: 'VIEW_ACCOUNTS_SETUP'
      }
    ]
  }
]

export const createNavigationMenuItems = (
  t: (key: string) => string,
  isShopConnected: boolean,
  isUserConfigured: boolean,
  hasOverDueInvoices: boolean,
  options?: { isMetaConnected?: boolean; hasEnabledPixels?: boolean; hasAdsIqPermission?: boolean | undefined }
): NavigationItem[] => {
  const isDisabled = !isUserConfigured || hasOverDueInvoices

  return [
    {
      id: 'home',
      title: 'Home',
      icon: House,
      path: '/home',
      disabled: isDisabled,
      rbacPermission: 'TAB_COPILOT',
      showNewBadge: shouldShowNavNewBadgeById('home')
    },
    {
      id: 'onboarding',
      title: t('onboarding.title'),
      icon: HandWaving,
      path: '/onboarding-v2',
      disabled: isDisabled,
      rbacPermission: null,
      conditionallyHidden: isShopConnected
    },
    {
      id: 'analytics',
      title: t('analytics.title'),
      icon: ChartLineUp,
      path: '/analytics',
      disabled: isDisabled,
      rbacPermission: 'TAB_ANALYTICS',
      children: [
        {
          id: 'alerts',
          title: t('alerts.title'),
          path: '/alerts',
          disabled: isDisabled,
          // TODO: Genish Change this permission if needed
          rbacPermission: 'TAB_ANALYTICS',
          icon: Compass
        }
      ]
    },
    {
      id: 'overview',
      title: t('overview'),
      icon: Compass,
      path: '/overview',
      disabled: isDisabled,
      rbacPermission: 'TAB_OVERVIEW'
    },
    {
      id: 'orders',
      title: t('nav_orders'),
      icon: Package,
      path: '/orders',
      disabled: isDisabled,
      rbacPermission: 'TAB_ORDERS',
      children: [
        {
          id: 'abandoned-checkouts',
          title: t('abandoned_checkouts'),
          icon: Package,
          path: '/abandoned-checkouts',
          disabled: isDisabled,
          rbacPermission: 'TAB_ABANDONED_CHECKOUTS'
        },
        {
          id: 'checkout-links',
          title: t('checkout_links.title'),
          icon: Package,
          path: '/checkout-links',
          disabled: isDisabled,
          rbacPermission: 'TAB_ORDERS'
        }
      ]
    },

    {
      id: 'discounts',
      title: t('discounts'),
      icon: SealPercent,
      path: '/discounts',
      disabled: isDisabled,
      rbacPermission: 'TAB_DISCOUNTS',
      children: [
        {
          id: 'payment-offers',
          title: 'Payment Offers',
          icon: SealPercent,
          path: '/payment-offers',
          disabled: isDisabled,
          rbacPermission: 'TAB_PAYMENT_OFFERS'
        },
        {
          id: 'discounts-sets',
          title: 'Sets',
          icon: SealPercent,
          path: '/discounts#sets',
          disabled: isDisabled,
          rbacPermission: 'TAB_DISCOUNTS'
        },
        {
          id: 'discounts-callout-cards',
          title: 'Callout Cards',
          icon: SealPercent,
          path: '/discounts#callout_cards',
          disabled: isDisabled,
          rbacPermission: 'TAB_DISCOUNTS'
        },
        {
          id: 'discounts-exit-coupons',
          title: 'Exit Coupons',
          icon: SealPercent,
          path: '/discounts#exit_coupons',
          disabled: isDisabled,
          rbacPermission: 'TAB_DISCOUNTS'
        }
      ]
    },
    {
      id: 'rewards',
      title: t('rewards'),
      icon: Gift,
      path: '/rewards',
      disabled: isDisabled,
      rbacPermission: 'TAB_REWARDS'
    },
    {
      id: 'segments',
      title: t('segments'),
      icon: UsersThree,
      path: '/segments',
      disabled: isDisabled,
      rbacPermission: 'TAB_SEGMENTS'
    },
    {
      id: 'ads-iq',
      title: t('ads_iq.title'),
      icon: Megaphone,
      path: options?.hasAdsIqPermission ? '/ads-iq' : '/ads-iq/real-estate',
      disabled: isDisabled,
      rbacPermission: options?.hasAdsIqPermission !== undefined ? null : 'TAB_ADS_IQ',
      showNewBadge: shouldShowNavNewBadgeById('ads-iq'),
      children:
        options?.hasAdsIqPermission && options?.isMetaConnected && options?.hasEnabledPixels
          ? [
              {
                id: 'event-health',
                title: t('ads_iq.event_health.title'),
                icon: Flag,
                path: '/ads-iq/event-health',
                disabled: isDisabled,
                rbacPermission: null
              }
            ]
          : undefined
    },
    {
      id: 'automations',
      title: t('automations'),
      icon: Lightning,
      path: '/automations',
      disabled: isDisabled,
      rbacPermission: 'TAB_AUTOMATIONS'
    },
    {
      id: 'reports',
      title: t('Reports'),
      icon: Scroll,
      path: '/download/report',
      disabled: isDisabled,
      rbacPermission: 'TAB_DOWNLOAD_REPORTS'
    },
    {
      id: 'app-store',
      title: t('app_store'),
      icon: Storefront,
      path: '/app-store',
      disabled: isDisabled,
      rbacPermission: 'TAB_APP_STORE',
      hidden: true
    },
    {
      id: 'apps-integrations',
      title: t('apps_integrations'),
      icon: Storefront,
      path: '/apps-integrations',
      disabled: isDisabled,
      rbacPermission: 'TAB_APP_STORE',
      hidden: true
    },
    {
      id: 'support',
      title: t('support'),
      icon: Question,
      path: '/support',
      disabled: isDisabled,
      rbacPermission: 'TAB_SUPPORT',
      hidden: true
    },
    {
      id: 'settings',
      title: t('settings'),
      icon: Gear,
      path: '/settings',
      disabled: isDisabled,
      rbacPermission: 'TAB_SETTINGS',
      hidden: true
    },
    {
      id: 'billing',
      title: t('billing.title'),
      icon: MoneyWavy,
      path: '/billing',
      disabled: isDisabled,
      rbacPermission: 'TAB_INVOICES',
      hidden: true
    }
  ]
}
